<template>
  <v-navigation-drawer
    v-if="isSendEmailAccountEditDrawerOpen"
    :value="isSendEmailAccountEditDrawerOpen"
    @input="inputSendEmailAccountEditDrawer"
    width="45%"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
  >
    <BaseToolbar
      :button-save="true"
      color="#2661FF"
      :dark="true"
      @close="close"
      @save="submit"
      :loader-save="loading"
      :title="$t('organization.details.tabs.integrations.amazon_ses.title')"
      type-title="icon"
      icon="edit"
    />
    <v-row class="pa-4">
      <v-col cols="12" class="mt-6">
        <h2 class="title text_color d-flex justify-center">
          Editar cuenta de envío de correos
        </h2>
        <p class="subtitle-1 text-center" style="color: #2661FF;">
          {{ sendEmailAccount.name }}
        </p>
      </v-col>
      <v-col cols="12">
        <v-card class="custom_card" flat>
          <v-card-title class="justify-center">
            <p class="body-2 text_color" style="word-break: keep-all;">
              Aquí podrás editar una cuenta de envío de correos utilizando las
              credenciales de Amazon Web Services.
            </p>
            <p
              class="subtitle-2 text-center"
              style="color: #d9534f;word-break: keep-all;"
            >
              ¡Importante! Al guardar los cambios, se deberá volver a configurar
              las cuentas de las organizaciones.
            </p>
          </v-card-title>
          <v-card-text>
            <v-form ref="credentials-form">
              <v-row no-gutters>
                <!------------------------------------------>
                <!-- NAME ---------------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <label for="name" class="text_color">
                    Nombre
                  </label>
                  <v-text-field
                    id="name"
                    v-model="credentials.name"
                    :rules="[rules.required]"
                    class="rounded-lg"
                    placeholder="Nombre"
                    outlined
                    dense
                    clearable
                  />
                </v-col>
                <!------------------------------------------>
                <!-- ACCESS KEY ID ------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <label for="awsAccessKeyId" class="text_color">
                    Access Key ID
                  </label>
                  <v-text-field
                    id="awsAccessKeyId"
                    v-model="credentials.awsAccessKeyId"
                    :rules="[rules.required]"
                    class="rounded-lg"
                    placeholder="Access Key ID"
                    outlined
                    dense
                    clearable
                  />
                </v-col>
                <!------------------------------------------>
                <!-- ACCESS KEY SECRET --------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <label for="awsSecretAccessKey" class="text_color">
                    Access Key Secret
                  </label>
                  <v-text-field
                    id="awsSecretAccessKey"
                    v-model="credentials.awsSecretAccessKey"
                    :rules="[rules.required]"
                    class="rounded-lg"
                    placeholder="Access Key Secret"
                    outlined
                    dense
                    clearable
                  />
                </v-col>
                <!------------------------------------------>
                <!-- REGION -------------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <label for="region" class="text_color">
                    Region
                  </label>
                  <v-autocomplete
                    id="region"
                    v-model="credentials.awsRegion"
                    :items="regions"
                    :rules="[rules.required]"
                    class="rounded-lg"
                    placeholder="Region"
                    outlined
                    dense
                    clearable
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import BaseToolbar from '../../BaseToolbar.vue'

export default {
  name: 'EditSendEmailAccount',
  components: {
    BaseToolbar
  },
  data() {
    return {
      loading: false,
      credentials: {
        id: null,
        name: null,
        awsAccessKeyId: null,
        awsSecretAccessKey: null,
        awsRegion: null
      },
      rules: {
        required: value => !!value || 'Campo requerido'
      }
    }
  },
  created() {
    this.credentials = JSON.parse(JSON.stringify(this.sendEmailAccount))
  },
  computed: {
    ...mapState({
      regions: ({ onboarding: { aws } }) => aws.regions,
      sendEmailAccount: ({ onboarding: { aws } }) => aws.sendEmailAccount,
      isSendEmailAccountEditDrawerOpen: ({ onboarding: { aws } }) =>
        aws.isSendEmailAccountEditDrawerOpen
    })
  },
  methods: {
    ...mapActions({
      updateSendEmailAccount: 'onboarding/updateSendEmailAccount'
    }),
    ...mapMutations({
      toggleSendEmailAccountEditDrawer:
        'onboarding/toggleSendEmailAccountEditDrawer'
    }),
    inputSendEmailAccountEditDrawer(arg) {
      if (!arg) {
        this.toggleSendEmailAccountEditDrawer(false)
      }
    },
    close() {
      this.toggleSendEmailAccountEditDrawer(false)
    },
    async submit() {
      const validation = this.$refs['credentials-form'].validate()

      if (!validation) return

      this.loading = true
      const { success } = await this.updateSendEmailAccount(this.credentials)
      this.loading = false

      if (success) {
        this.toggleSendEmailAccountEditDrawer(false)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
